import React, { useEffect, useState } from 'react'
import Box from '@mui/system/Box'
import useMediaQuery from '@mui/material/useMediaQuery'
import Icon from '@mui/material/Icon'
import Typography from '@mui/material/Typography'
import AdxPopper from 'components/reusable/AdxPopper'
import { useLocation, useNavigate } from 'react-router-dom'
import AdxInput from 'components/custom/AdxInput'
import { InputAdornment } from '@mui/material'
import { handleView } from 'module/claim/pages/report/functions'
import AdxPdfImageViewer from 'components/reusable/AdxPdfImageViewer'
import AdxButton from 'components/custom/AdxButton'
import ClaimExpenseRejectModal from './claim/ClaimExpenseRejectModal'
import { useMutation, useQueryClient } from 'react-query'
import { rejectExpense } from 'services/api/modules/claim/approval-center/report'
// import { checkIfPdf, handleView } from "../../functions";

const ExpenseListPayable = ({
  editable,
  category,
  date,
  merchant,
  description,
  amount,
  proofLink,
  file,
  name,
  onChange,
  onBlur,
  value,
  errorMessage,
  isErrorShown,
  id,
  reportId,
}) => {
  const navigate = useNavigate()
  const location = useLocation()
  const backgroundLocation = location
  const queryClient = useQueryClient()

  // State for reject modal
  const [isRejectModalOpen, setIsRejectModalOpen] = useState(false)

  // Mutation for rejecting expense
  const {
    mutate: rejectExpenseMutation,
    isLoading: isRejecting,
    error: rejectError,
  } = useMutation(
    (feedback) => rejectExpense(reportId, id, feedback),
    {
      onSuccess: async () => {
        await Promise.all([
          queryClient.invalidateQueries(['singleApprovalReport', reportId]),
          queryClient.invalidateQueries(['getClaimRequestById', reportId]),
          queryClient.invalidateQueries('getClaimRequestById'),
          queryClient.invalidateQueries('getDashboardApprovals'),
          queryClient.invalidateQueries('currentRequest'),
        ])
        setIsRejectModalOpen(false)
      },
      onError: (error) => {
        console.error('Failed to reject expense:', error)
      },
    }
  )

  const handleRejectClick = () => {
    setIsRejectModalOpen(true)
  }

  const handleRejectSubmit = (feedback) => {
    rejectExpenseMutation(feedback)
  }

  const handleRejectClose = () => {
    setIsRejectModalOpen(false)
  }

  const handleOpenProofLink = (event) => {
    event.stopPropagation()
    window.open(proofLink, '_blank', 'noopener,noreferrer')
  }

  return (
    <Box
      width={1}
      bgcolor="white.main"
      borderRadius={3}
      mb={2}
      border={2}
      borderColor="gray-line.main"
    >
      <Box
        width={1}
        padding={{ xs: 2, lg: 2 }}
        paddingRight={{ xs: 2, lg: 3 }}
        boxSizing="border-box"
        borderColor="gray-line.main"
      >
        <Box display="flex" justifyContent="space-between" alignItems="center">
          <Box width={{ xs: 1, lg: 4 / 5 }} display="flex" alignItems="center" columnGap={2}>
            <Box
              width={90}
              height={90}
              border="2px dashed"
              borderColor="gray-line.main"
              borderRadius={1}
              onClick={() => handleView(file?.url)}
              sx={{
                cursor: 'pointer',
                objectFit: 'cover',
                objectPosition: '0% 0%',
                overflow: 'hidden',
              }}
            >
              <AdxPdfImageViewer fileUrl={file?.url} />
            </Box>
            <Box
              width={{ xs: 1, lg: 'calc(100% - 100px)' }}
              minHeight={85}
              display="flex"
              flexDirection="column"
              justifyContent="space-between"
              rowGap={0.75}
            >
              <Box>
                <Typography
                  noWrap
                  component="span"
                  variant="body1"
                  color="alternate.main"
                  fontWeight="bold"
                  textTransform="capitalize"
                >
                  {category}
                </Typography>
                <Box display={'flex'} alignItems={'center'} columnGap={1.5} mt={0.5}>
                  <Typography
                    noWrap
                    component="span"
                    variant="body2"
                    color="text.secondary"
                    textTransform="capitalize"
                  >
                    {date}
                  </Typography>
                  <Icon
                    sx={{
                      fontSize: 7,
                      color: 'text.secondary',
                    }}
                  >
                    circle_rounded
                  </Icon>
                  <Typography
                    noWrap
                    component="span"
                    variant="body2"
                    color="text.secondary"
                    textTransform="capitalize"
                  >
                    {merchant}
                  </Typography>
                </Box>
              </Box>
              <Typography
                display={{ xs: 'none', lg: 'block' }}
                width={6 / 7}
                minWidth={400}
                variant="body2"
                color="text.secondary"
                textTransform="capitalize"
              >
                {description}
              </Typography>
              {proofLink && (
                <Box
                  component="button"
                  type="button"
                  onClick={handleOpenProofLink}
                  sx={{
                    display: 'inline-flex',
                    alignItems: 'center',
                    alignSelf: 'flex-start',
                    gap: 0.75,
                    border: 1,
                    borderColor: 'alternate.light',
                    borderRadius: '4.5px',
                    bgcolor: 'alternate.light',
                    color: 'alternate.main',
                    px: 1,
                    py: 0.5,
                    cursor: 'pointer',
                    font: 'inherit',
                    '&:hover': {
                      bgcolor: 'primary.light',
                      borderColor: 'alternate.main',
                    },
                  }}
                >
                  <Icon sx={{ fontSize: 16 }}>open_in_new</Icon>
                  <Typography variant="body2" fontWeight={600}>
                    Open proof link
                  </Typography>
                </Box>
              )}
              <Typography
                display={{ xs: 'flex', lg: 'none' }}
                noWrap
                component="span"
                variant="h4"
                fontWeight="bold"
                color="alternate.main"
              >
                RM {amount}
              </Typography>
            </Box>
          </Box>
          <Box
            width={1 / 5}
            display={{ xs: 'none', lg: 'flex' }}
            justifyContent="end"
            alignCenter="center"
            columnGap={1}
          >
            <Typography
              noWrap
              component="span"
              variant="h4"
              fontWeight="bold"
              color="alternate.main"
            >
              RM {amount}
            </Typography>
            <AdxPopper
              disablePortal
              linePlacement={proofLink ? [2] : undefined}
              placement="bottom-end"
              sx={{ width: 220, boxShadow: '0px 0px 10px lightgray' }}
            >
              {proofLink && (
                <Typography
                  variant="body1"
                  color="dark-text.main"
                  onClick={handleOpenProofLink}
                >
                  Open proof link
                </Typography>
              )}
              <Typography
                variant="body1"
                color="dark-text.main"
                onClick={() => handleView(file?.url)}
              >
                View attachment
              </Typography>
            </AdxPopper>
          </Box>
        </Box>
      </Box>
      {editable && (
        <Box
          display="flex"
          justifyContent="space-between"
          alignItems="center"
          padding={{ xs: 2, lg: 3 }}
          borderTop={2}
          borderColor="gray-line.main"
        >
          <Box display="flex" alignItems="center" columnGap={2}>
            <Typography variant="body1" color="text.secondary">
              Reimburseable amount
            </Typography>
            <AdxInput
              name={name}
              onChange={onChange}
              onBlur={onBlur}
              value={value}
              type="number"
              inputProps={{
                min: '0.00',
                step: '0.01',
              }}
              sx={{ width: 150 }}
              sxInput={{ width: 150 }}
              startAdornment={
                <InputAdornment position="start">
                  <Typography color="dark-text.main">RM</Typography>
                </InputAdornment>
              }
              errorMessage={errorMessage}
              isErrorShown={isErrorShown}
              errorTextAlign="right"
            />
          </Box>
          <Box display="flex" alignItems="center" columnGap={1}>
            <AdxButton
              variant="outlined"
              color="error"
              size="small"
              onClick={handleRejectClick}
              sx={{
                minWidth: 'auto',
                px: 2,
              }}
            >
              Reject
            </AdxButton>
          </Box>
        </Box>
      )}

      {/* Reject Expense Modal */}
      <ClaimExpenseRejectModal
        isOpen={isRejectModalOpen}
        onClose={handleRejectClose}
        onSubmit={handleRejectSubmit}
        isLoading={isRejecting}
        expenseDescription={description}
      />
    </Box>
  )
}

export default ExpenseListPayable
